__turbopack_context__.v({
  "followButton": "styles-module-scss-module__4dgfza__followButton",
});
